import { render, staticRenderFns } from "./CarousselGallery.vue?vue&type=template&id=c9cfdbf4&scoped=true&"
import script from "./CarousselGallery.vue?vue&type=script&lang=js&"
export * from "./CarousselGallery.vue?vue&type=script&lang=js&"
import style0 from "./CarousselGallery.vue?vue&type=style&index=0&id=c9cfdbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cfdbf4",
  null
  
)

export default component.exports